import { Component, OnInit, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-public-layout',
    templateUrl: './public-layout.component.html',
    styleUrls: ['./public-layout.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PublicLayoutComponent implements OnInit, OnDestroy {
  currentDate = DateTime.now().toLocaleString(DateTime.DATE_FULL);
  public isCollapsed = true;

  ngOnInit() {
    var html = document.getElementsByTagName('html')[0];
    // html.classList.add("public-layout");
    var body = document.getElementsByTagName('body')[0];
    body.classList.add('bg-default');
    var navbar = document.getElementsByClassName('navbar-horizontal')[0];
    navbar.classList.add('navbar-light');
    navbar.classList.add('navbar-transparent');
  }

  ngOnDestroy() {
    var html = document.getElementsByTagName('html')[0];
    // html.classList.remove("public-layout");
    var body = document.getElementsByTagName('body')[0];
    body.classList.remove('bg-default');
    var navbar = document.getElementsByClassName('navbar-horizontal')[0];
    navbar.classList.remove('navbar-light');
    navbar.classList.remove('navbar-transparent');
  }
}
